module.exports = __webpack_public_path__ + "img/SCT.56a87b22.svg";